import { render } from "./API.vue?vue&type=template&id=6a0b0b1d"
import script from "./API.vue?vue&type=script&lang=js"
export * from "./API.vue?vue&type=script&lang=js"

import "./API.vue?vue&type=style&index=0&id=6a0b0b1d&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__